"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgBack(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M10.607 1L12 2.476 7.73 7H20v2H7.73L12 13.524 10.607 15 4 8z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Back')(SvgBack);
//# sourceMappingURL=Back.js.map